import { useContext, useEffect } from 'react'
import { BreadcrumbsContext } from '../BreadcrumbsContext'
import { BreadcrumbItem } from '../BreadcrumbsContext.types'

export const useBreadcrumbs = (breadcrumbs?: BreadcrumbItem[]) => {
  const context = useContext(BreadcrumbsContext)

  if (context === undefined) {
    throw new Error('useBreadcrumbs must be used within an BreadcrumbsContextController')
  }

  useEffect(() => {
    if (!breadcrumbs) return

    if (JSON.stringify(breadcrumbs) !== JSON.stringify(context.breadcrumbs)) {
      context.setBreadcrumbs(breadcrumbs)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [breadcrumbs])

  return { breadcrumb: context.breadcrumbs }
}
